
import { ENotification, ENotificationPosition, IConfirm } from '../../models/components/notification';
import ReactDOM from 'react-dom';
import React, { createElement } from 'react';
import Translator from '../../core/i18n';
import { create } from 'domain';
import { ReactComponent } from '*.svg';
import { Common } from '../../core/common';
import { ModalFooter } from 'react-bootstrap';
import { Footer } from 'react-bootstrap/lib/Panel';
import * as Icons from 'react-icons/md';
import imgPdf from '../../static/images/coloricons/pdf.svg';
import imgWord from '../../static/images/coloricons/word.svg';
import imgExcel from '../../static/images/coloricons/excel.svg';
import imgPowerpoint from '../../static/images/coloricons/powerpoint.svg';
import imgVideo from '../../static/images/coloricons/video.svg';
import imgSound from '../../static/images/coloricons/sound.svg';
import imgImage from '../../static/images/coloricons/image.svg';

let _common : Common;
_common = new Common();
const T = Translator.create();

export class Notification extends React.Component<any> {
    
       public static setNotification = (type: 'info' | 'success' | 'error' | 'warning', text: string,
        position?: 'default' | 'topLeft' | 'topRight' | 'bottomLeft' | 'bottomRight' | null,
        timeOut?: number | 'fixed' /*Default timeOut:6000 */) => {
        
        let typeClass;
        let typeIcon;
        // Default timeOut
        if (!timeOut) timeOut = 6000;
        // Default Position
        if (!position) position = 'topRight';

        //#region notification set type
        if (type === 'error') { typeClass = 'alert-danger'; typeIcon = 'warning'; } else if (type === 'success') {
            typeClass = 'alert-sucess'; typeIcon = 'done';
        } else if (type === 'warning') {
            typeClass = 'alert-warning'; typeIcon = 'notifications_none';
        } else if (type === 'info') {
            typeClass = 'alert-info'; typeIcon = 'info_outline';
        } else {
            typeClass = 'alert-info';
            typeIcon = 'info_outline';
        }
        //#endregion
 
        //#region existing notification and create notification element
        let getRootNotification;
        const getRootBody = document.getElementsByTagName('body');
        if (document.getElementsByClassName('notificationTopRight')[0] && position === 'topRight') {
            getRootNotification = document.getElementsByClassName('notificationTopRight')[0];
        } else if (document.getElementsByClassName('notificationTopleft')[0] && position === 'topLeft') {
            getRootNotification = document.getElementsByClassName('notificationTopleft')[0];
        } else if (document.getElementsByClassName('notificationBottomleft')[0] && position === 'bottomLeft') {
            getRootNotification = document.getElementsByClassName('notificationBottomleft')[0];
        } else if (document.getElementsByClassName('notificationBottomRight')[0] && position === 'bottomRight') {
            getRootNotification = document.getElementsByClassName('notificationBottomRight')[0];
        } else {
            //#region  set Create and Position Notification
            getRootNotification = document.createElement('div');
            getRootNotification.classList.add('notification_component');
            if (position === 'topLeft') {
                getRootNotification.classList.add('notificationTopleft');
            }
            if (position === 'topRight') {
                getRootNotification.classList.add('notificationTopRight');
            }
            if (position === 'bottomLeft') {
                getRootNotification.classList.add('notificationBottomleft');
            }
            if (position === 'bottomRight') {
                getRootNotification.classList.add('notificationBottomRight');
            }
            //#endregion
        }
        //#endregion

        //#region create elements and add class 
        const notificationDiv = document.createElement('div');
        const childMediaDiv = document.createElement('div');
        const toastIcon = document.createElement('i');
        const toastCloseIcon = document.createElement('i');
        const childMediaBody = document.createElement('div');
        const childMediaBodySpan = document.createElement('span');
        toastCloseIcon.classList.add('material-icons');
        toastCloseIcon.innerHTML = 'close';
        childMediaBody.classList.add('media-body');
        childMediaBody.classList.add('alert-rtl-margin');
        toastIcon.classList.add('material-icons');
        toastIcon.innerHTML = typeIcon;
        childMediaDiv.classList.add('media');
        notificationDiv.classList.add('alert');
        notificationDiv.classList.add('alert-rtl');
        notificationDiv.classList.add(typeClass);
        (typeIcon == 'done') && toastIcon.classList.add('icon-rtl');
        notificationDiv.classList.add('showNotification');
        toastCloseIcon.style.cursor = 'pointer';
        notificationDiv.style.position = 'relative';
        childMediaBodySpan.innerText = text;
        notificationDiv.appendChild(childMediaDiv);
        childMediaDiv.appendChild(toastIcon);
        childMediaDiv.appendChild(childMediaBody);
        childMediaDiv.appendChild(toastCloseIcon);
        childMediaBody.appendChild(childMediaBodySpan);
        //#endregion

        //#region close onclik
        toastCloseIcon.onclick = (() => {
            setTimeout(() => {
                notificationDiv.classList.remove('notificationDiv');
                notificationDiv.classList.add('closeNotification');
            }, 0);
            setTimeout(() => {
                notificationDiv.remove();
            }, 1000);
        });
        //#endregion

        //#region position options existing or creating -- append child notification root element
        if (getRootNotification) {
            const notificationTopRight = document.getElementsByClassName('notificationTopRight');
            const notificationTopleft = document.getElementsByClassName('notificationTopleft');
            const notificationBottomleft = document.getElementsByClassName('notificationBottomleft');
            const notificationBottomRight = document.getElementsByClassName('notificationBottomRight');
            if (notificationTopRight && notificationTopRight[0] && position === 'topRight') {
                document.getElementsByClassName('notificationTopRight')[0].appendChild(notificationDiv);
            } else if (notificationTopleft && notificationTopleft[0] && position === 'topLeft') {
                document.getElementsByClassName('notificationTopleft')[0].appendChild(notificationDiv);
            } else if (notificationTopleft && notificationBottomleft[0] && position === 'bottomLeft') {
                document.getElementsByClassName('notificationBottomleft')[0].appendChild(notificationDiv);
            } else if (notificationTopleft && notificationBottomRight[0] && position === 'bottomRight') {
                document.getElementsByClassName('notificationBottomRight')[0].appendChild(notificationDiv);
            } else {
                getRootNotification.appendChild(notificationDiv);
                getRootBody[0].appendChild(getRootNotification);
            }
        }
        //#endregion

        //#region timeout notification
        if (timeOut !== 'fixed') {
            setTimeout(() => {
                notificationDiv.classList.remove('notificationDiv');
                notificationDiv.classList.add('closeNotification');
            }, (timeOut) ? timeOut : 5000);
            setTimeout(() => {
                notificationDiv.remove();
            }, (timeOut) ? timeOut + 1500 : 6500);
        }
        //#endregion 
    }
}

// tslint:disable-next-line:max-classes-per-file
export class Confirm extends React.Component<any> {

    public static returnFileIconByExt = (ext: any) => {
        let fileIcon = null;

        if (ext === 'pdf' || ext === 'ppdf') {
            fileIcon = imgPdf;
        } else if (/docx?/gi.test(ext)) {
            fileIcon = imgWord;
        } else if (/xlsx?/gi.test(ext)) {
            fileIcon = imgExcel;
        } else if (/pptx?/gi.test(ext)) {
            fileIcon = imgPowerpoint;
        } else if (/mp4/gi.test(ext)) {
            fileIcon = imgVideo;
        } else if (/mp3/gi.test(ext)) {
            fileIcon = imgSound;
        } else if (/jpe?g|png|gif/gi.test(ext)) {
            fileIcon = imgImage;
        } else {
            fileIcon = <Icons.MdInsertDriveFile size="22" />;
        }
        return fileIcon;
    }

    public static setConfirm = (type: 'normal' | 'deleteMessage' | 'allDeleteMessage' | 'checkControl' | 'twoOption' ,
       
       
        confirmOnClick: any,
        normalMessage?: string | null,
        deleteComment?: string | null,
        messageInfo?: { warningText: string, userImagePath: string, nameSurname: string, date: string, message: string, fileName: string } | null,
        allMessageParams?: { groupName: string, groupDescription: string, allMessageCount: number, participantCount: number, imagePath: string, },
        notTabIndex?: boolean,
        secondOptionOnClick?: any,
        firstButtonText?: string | null,
        secondButtonText?: string | null,
        spinnerHtml?: any) => {
        const getBodyElement = document.getElementsByTagName('body');
        const confirmModal = document.createElement('div');
        confirmModal.className = 'modal fade';

        let isDeletedImage = false;
        let isDeletedImageValue :any;


        if (type === 'deleteMessage') {
            confirmModal.classList.add('alert-detelet-message');
            if (messageInfo && !messageInfo.userImagePath) {
                messageInfo.userImagePath = 'data:image/png;base64,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';
            }

            if(messageInfo && messageInfo.fileName!='')
            {   
                    let fileIcon = null;
                    if (messageInfo.fileName && messageInfo.fileName.lastIndexOf('.') > 0) {
                        const ext = messageInfo.fileName.substr(messageInfo.fileName.lastIndexOf('.') + 1);
                        fileIcon = this.returnFileIconByExt(ext)
                    } else {
                        fileIcon = <Icons.MdInsertDriveFile size="22" />;
                    }
                    isDeletedImage = true;

                    isDeletedImageValue =  fileIcon;

            }
            else if(messageInfo && messageInfo.message)
            {
                const imgTagPattern = /<img\s+[^>]*src="[^"]*"[^>]*>/i;
                if (imgTagPattern.test(messageInfo.message)){
                    isDeletedImage = true;
                    let regex = /src="([^"]+)"/;
                    let match = messageInfo.message.match(regex);
                    if (match) {
                        isDeletedImageValue = match[1];
                    }
                    
                }
                else
                {
                    messageInfo.message = messageInfo.message.replace(/<\/?[^>]+(>|$)/g, '')
                }
        
            }
        }

        if (type === 'allDeleteMessage') {
            confirmModal.classList.add('alert-detelet-message');
        }
        else if (type === 'normal') {
            confirmModal.classList.add('alert-simple');
        }
        else if (type === 'checkControl') {
            confirmModal.classList.add('alert-simple');
        }
        else if (type === 'twoOption') {
            confirmModal.classList.add('alert-simple');
        }

        confirmModal.id = 'exampleModal';
        confirmModal.setAttribute('role', 'dialog');

        if (!notTabIndex) {
            confirmModal.tabIndex = -1;
        }

        confirmModal.setAttribute('aria-labelledby', 'exampleModalLabel');
        
        confirmModal.style.display = 'block';
        confirmModal.style.zIndex = '999999999';
        confirmModal.style.backgroundColor = 'rgba(0,0,0,0.5)';
        confirmModal.setAttribute('aria-hidden', 'true');
        const dialogCentered = document.createElement('div');
        dialogCentered.className = 'modal-dialog modal-dialog-centered';
        dialogCentered.setAttribute('role', 'document');
        confirmModal.appendChild(dialogCentered);
        const modalContent = document.createElement('div');
        modalContent.className = 'modal-content';
        dialogCentered.appendChild(modalContent);
        const closeButton = document.createElement('a');
        closeButton.style.marginInlineEnd = "0px";
        closeButton.className = 'close';
        closeButton.setAttribute('data-dismiss', 'modal');
        closeButton.setAttribute('aria-label', 'close');
        closeButton.setAttribute('type', 'button');

        if (type === 'normal' || !type) {
            modalContent.appendChild(closeButton);
        } 
        else if (type === 'checkControl' || !type) {
            modalContent.appendChild(closeButton);
        }
        else if (type === 'twoOption' || !type) {
            modalContent.appendChild(closeButton);
        }

        const closeIcon = document.createElement('i');
        closeIcon.className = 'material-icons';
        closeIcon.innerHTML = 'close';
        closeButton.onclick = (() => {
            confirmModal.classList.remove('show');
            setTimeout(() => {
                confirmModal.remove();
            }, 500);
        });

        closeButton.appendChild(closeIcon);
        const modalTextCenter = document.createElement('div');
        modalTextCenter.className = 'modal-body text-center';
        const confirmIcon = document.createElement('i');
        confirmIcon.className = 'material-icons mb-3';
        confirmIcon.innerHTML = 'notifications_none';
        modalTextCenter.appendChild(confirmIcon);
        const confirmTitle = document.createElement('h3');
        confirmTitle.innerText = (normalMessage) ? normalMessage : 'Uyarı Başlığım';
        modalTextCenter.appendChild(confirmTitle);
        const confirmComment = document.createElement('p');
        confirmComment.innerText = (deleteComment) ? deleteComment :'';
        modalTextCenter.appendChild(confirmComment);

        // #region  set && create  confirm template ()confirm body
        if (type === 'deleteMessage' || type === 'allDeleteMessage') {
            const deleteMessageBody = document.createElement('div');
            const modalBody = document.createElement('div');
            modalBody.className = 'modal-body';
            deleteMessageBody.className = 'user-message';
            const messageHeader = document.createElement('div');
            messageHeader.className = 'message-header';
            const messageHeaderPhoto = document.createElement('img');
            messageHeaderPhoto.onerror = (e: any) => _common.OnErrorImageSrc(e, 'avatar');
            messageHeaderPhoto.src = (messageInfo && messageInfo.userImagePath) ? messageInfo.userImagePath : (allMessageParams && allMessageParams.imagePath) ? allMessageParams.imagePath : '';
            messageHeader.appendChild(messageHeaderPhoto);
            const userName = document.createElement('h6');
            userName.innerText = (messageInfo && messageInfo.nameSurname) ? messageInfo.nameSurname : (allMessageParams && allMessageParams.groupName) ? allMessageParams.groupName : '';
            const date = document.createElement('span');
            date.innerText = (messageInfo && messageInfo.date) ? messageInfo.date : '';
            messageHeader.appendChild(userName);
            messageHeader.appendChild(date);
            const modalHeader = document.createElement('div');
            modalHeader.className = 'modal-header';
            const modalHeaderH6 = document.createElement('h6');
            modalHeaderH6.innerText = T.t('r_gen_delete_message');
            modalHeader.appendChild(modalHeaderH6);
            modalContent.appendChild(modalHeader);
            const modalContentMessage = document.createElement('p');
            modalContentMessage.innerText = (messageInfo && messageInfo.warningText) ? messageInfo.warningText : (allMessageParams) ? 'Aşağıdaki gruba ait tüm mesajları silmek istediniz. Bu işlemin geri dönüşü yoktur.' : '';
            modalContent.appendChild(modalContentMessage);
            modalHeader.appendChild(closeButton);
            const messageBody = document.createElement('div');
            messageBody.className = 'message-body';
            deleteMessageBody.appendChild(messageHeader);

            if(isDeletedImage)
            {
                const messageBodyPhoto = document.createElement('img');
                messageBodyPhoto.src = isDeletedImageValue;
                messageBodyPhoto.style.paddingTop = "5px";
                messageBodyPhoto.style.width = "100%";
                messageBodyPhoto.height = 100;
                deleteMessageBody.appendChild(messageBodyPhoto);
                
            }
            else
            {
                messageBody.innerText = (messageInfo && messageInfo.message) ? messageInfo.message : (allMessageParams && allMessageParams.groupDescription) ? allMessageParams.groupDescription : '';
                deleteMessageBody.appendChild(messageBody);
            }
            modalBody.appendChild(deleteMessageBody);

            if (type === 'allDeleteMessage') {
                const groupStats = document.createElement('div');
                groupStats.className = 'row group-stats';
                const col1 = document.createElement('div');
                col1.className = 'col-1';
                const col2 = document.createElement('div');
                col2.className = 'col-5';
                const participant = document.createElement('span');
                participant.className = 'stats-label';
                participant.innerText = 'Katılımcı';
                const participantCount = document.createElement('h5');
                participantCount.innerText = (allMessageParams && allMessageParams.participantCount) ? allMessageParams.participantCount.toString() : '';
                col2.appendChild(participant);
                col2.appendChild(participantCount);
                const col3 = document.createElement('div');
                col3.className = 'col-5';
                const documentallMessage = document.createElement('span');
                documentallMessage.innerText = 'Toplam Mesaj';
                documentallMessage.className = 'stats-label';
                const documentallMessageCount = document.createElement('h5');
                documentallMessageCount.innerText = (allMessageParams && allMessageParams.allMessageCount) ? allMessageParams.allMessageCount.toString() : '';
                modalHeaderH6.innerText = 'Tüm mesajları sil';
                col3.appendChild(documentallMessage);
                col3.appendChild(documentallMessageCount);
                groupStats.appendChild(col1);
                groupStats.appendChild(col2);
                groupStats.appendChild(col3);
                deleteMessageBody.appendChild(groupStats);
            }

            modalContent.appendChild(modalBody);
        }
        
        if ( type === 'checkControl') {
            modalContent.appendChild(modalTextCenter);
            
             // #endregion 
            /* const modalFooter_check = document.createElement('div');
            modalFooter_check.className = 'modal-footer';
            const cancelButton = document.createElement('button');
            cancelButton.type = 'button';
            cancelButton.className = 'btn btn-danger';
            cancelButton.setAttribute('data-dismiss', 'modal');
            cancelButton.innerText = T.t('r_no');
            cancelButton.onclick = (() => {
                confirmModal.classList.remove('show');
                setTimeout(() => {
                    confirmModal.remove();
                }, 500);
            });
            modalFooter_check.appendChild(cancelButton);
            const confirmButton = document.createElement('button');
            confirmButton.type = 'button';
            confirmButton.className = 'btn btn-green';
            confirmButton.innerText = T.t('r_yes');
            confirmButton.onclick = (() => {
                confirmModal.classList.remove('show');
                confirmOnClick();
                setTimeout(() => {
                    confirmModal.remove();
                }, 500);
            });
            modalFooter_check.appendChild(confirmButton);
            modalContent.appendChild(modalFooter_check); */
            
        }

        if (!type || type === 'normal' || type === 'twoOption') {
            modalContent.appendChild(modalTextCenter);
        }

        // #endregion 

        const modalFooter = document.createElement('div');
        modalFooter.className = 'modal-footer';
        const cancelButton = document.createElement('a');
        cancelButton.type = 'button';

        if ( type === 'checkControl') {
            cancelButton.className = 'btn btn-danger';
            cancelButton.innerText = T.t('r_no');
        }
        else if (type === 'twoOption'){
            cancelButton.className = 'btn btn-primary text-light';
            cancelButton.innerText = secondButtonText!.toString();
        }
        else {
            cancelButton.className = 'btn btn-gray';
            cancelButton.innerText = T.t('r_cancel_button');
        }

        if ( type === 'twoOption') {
            cancelButton.onclick = (async () => {
                confirmModal.classList.remove('show');
                setTimeout(() => {
                    confirmModal.remove();
                }, 500);

                if (spinnerHtml != null && spinnerHtml != undefined){
                    var loadingModalDiv = document.createElement('div');
                    loadingModalDiv.id = 'copyLoading';
                    loadingModalDiv.classList.add('row');
                    loadingModalDiv.classList.add('modal');
                    loadingModalDiv.classList.add('modal-dialog-centered');
                    loadingModalDiv.classList.add('fade');

                    var loadingDiv = document.createElement('div');
                    loadingDiv.classList.add('spinner_bg');
                    
                    loadingModalDiv.setAttribute('role', 'dialog');
                    loadingModalDiv.tabIndex = -1;
                    
                    loadingModalDiv.setAttribute('aria-labelledby', 'exampleModalLabel');
                    loadingModalDiv.style.display = 'block';
                    loadingModalDiv.style.backgroundColor = 'rgba(0,0,0,0.5)';
                    loadingModalDiv.style.padding = '12.5% 35%';
                    loadingModalDiv.setAttribute('aria-hidden', 'true');

                    loadingModalDiv.appendChild(loadingDiv);

                    var donutDiv = document.createElement('div');
                    donutDiv.classList.add('donut');

                    loadingDiv.appendChild(donutDiv);

                    var loadingInnerDiv = document.createElement('span');
                    loadingInnerDiv.classList.add('report_title');
                    loadingInnerDiv.innerText = T.t('r_copying_activities');

                    loadingDiv.appendChild(loadingInnerDiv);

                    loadingModalDiv.classList.add('show');

                    document.body.appendChild(loadingModalDiv);
                    
                    await secondOptionOnClick();
                }
                else
                {
                    await secondOptionOnClick();
                }
            });
        } else {
            cancelButton.setAttribute('data-dismiss', 'modal');

            cancelButton.onclick = (() => {
                confirmModal.classList.remove('show');
                setTimeout(() => {
                    confirmModal.remove();
                }, 500);
            });
        }
        
        modalFooter.appendChild(cancelButton);
        const confirmButton = document.createElement('a');
        confirmButton.type = 'button';

        if (type === 'checkControl') {
            confirmButton.className = 'btn btn-green';
            confirmButton.innerText = T.t('r_yes');
        }else if (type === 'twoOption'){
            confirmButton.className = 'btn btn-green text-light';
            confirmButton.innerText = firstButtonText!.toString();
        }
         else {
            confirmButton.className = 'btn btn-green';
            
            if (secondButtonText && secondButtonText !== ''){
                confirmButton.innerText = secondButtonText!;
            }else{
                confirmButton.innerText = T.t('r_gen_delete');
            }
        }

        confirmButton.onclick = (() => {
            confirmModal.classList.remove('show');
            confirmOnClick();
            setTimeout(() => {
                confirmModal.remove();
            }, 500);

            if (spinnerHtml != null && spinnerHtml != undefined){
                spinnerHtml();
            }
        });

        modalFooter.appendChild(confirmButton);
            modalContent.appendChild(modalFooter);
            if (getBodyElement && getBodyElement[0]) {
                getBodyElement[0].appendChild(confirmModal);
                setTimeout(() => {
                    confirmModal.classList.add('show');
                }, 30);
            }
    }
}
